import { Pipe, PipeTransform } from '@angular/core';
import { NgxMaskPipe, NgxMaskOptions } from 'ngx-mask';
@Pipe({
  name: 'mask',
  standalone: true,
})
export class MaskPipe implements PipeTransform {
  private maskPipe: NgxMaskPipe = new NgxMaskPipe();

  transform(value: any, mask: string, config?: NgxMaskOptions): string {
    if (mask) {
      return this.maskPipe.transform(value, mask, config);
    }

    return value;
  }
}
